document.addEventListener("DOMContentLoaded", () => {
  const productGridContainer = document.querySelector("#ProductGridContainer");
  const loader = document.querySelector("#infinite-scroll-loader");
  let currentPage = 1;
  let isLoading = false;
  let hasMoreProducts = true; // Track if there are more products to load
  const backToTopBtn = document.createElement("button");

  // Style the back-to-top button
  backToTopBtn.textContent = "Back to Top";
  backToTopBtn.style.position = "fixed";
  backToTopBtn.style.bottom = "20px";
  backToTopBtn.style.left = "50%"; // Center horizontally
  backToTopBtn.style.transform = "translateX(-50%)"; // Adjust position to ensure it's centered
  backToTopBtn.style.padding = "10px 20px";
  backToTopBtn.style.backgroundColor = "#6a0dad"; // Purple background
  backToTopBtn.style.color = "white";
  backToTopBtn.style.border = "none";
  backToTopBtn.style.borderRadius = "5px";
  backToTopBtn.style.display = "none"; // Initially hide the button
  backToTopBtn.style.cursor = "pointer";
  document.body.appendChild(backToTopBtn);

  // Function to show or hide the "Back to Top" button
  const toggleBackToTopButton = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;

    // Show button only when the user reaches the very bottom of the page
    if (scrollHeight - scrollTop === clientHeight) {
      backToTopBtn.style.display = "block"; // Show the button at the very bottom
    } else {
      backToTopBtn.style.display = "none"; // Hide the button when not at the bottom
    }
  };

  // Scroll to top when button is clicked
  backToTopBtn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    // Hide the button after clicking
    backToTopBtn.style.display = "none"; // Hide the button when it's clicked
  });

  // Function to calculate the scroll trigger threshold dynamically
  const getScrollThreshold = () => {
    const isMobile = window.innerWidth <= 768; // Consider screens smaller than 768px as mobile
    return isMobile ? 1700 : 1100; // 300px before the bottom on mobile, 500px on desktop
  };

  // Handle scroll event: check scroll position and show/hide button
  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    const scrollThreshold = getScrollThreshold(); // Get dynamic threshold based on screen size

    // Load more products if the user is within threshold of the bottom
    if (scrollTop + clientHeight >= scrollHeight - scrollThreshold && hasMoreProducts) {
      loadMoreProducts();
    }

    // Show the "Back to Top" button when reaching the bottom
    toggleBackToTopButton();
  };

  const loadMoreProducts = async () => {
    if (isLoading || !hasMoreProducts) return; // Don't load if already loading or no more products
    isLoading = true;
    loader.style.display = "block"; // Show the loader

    // Apply shimmering effect to the loader
    loader.classList.add("shimmer");

    // Fetch the next page's products
    const nextPage = currentPage + 1;
    const url = `${window.location.pathname}?page=${nextPage}`;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to load more products");
      const html = await response.text();

      // Parse the new products
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newProducts = doc.querySelector("#ProductGridContainer").innerHTML.trim();

      // Check if the collection is empty (no products found)
      const emptyCollection = doc.querySelector(".collection--empty");

      if (!newProducts || emptyCollection) {
        hasMoreProducts = false; // No more products to load
        loader.style.display = "none"; // Hide the loader
        loader.classList.remove("shimmer"); // Remove shimmering effect
        window.removeEventListener("scroll", handleScroll); // Remove the scroll event listener
        console.log("No more products found.");
        return; // Stop further execution
      }

      // Append the new products to the existing grid
      productGridContainer.insertAdjacentHTML("beforeend", newProducts);

      // Update current page and loading state
      currentPage = nextPage;
      isLoading = false;
      loader.style.display = "none"; // Hide the loader
      loader.classList.remove("shimmer"); // Remove shimmering effect after loading

      // After loading new products, check if we're at the bottom
      toggleBackToTopButton();

    } catch (error) {
      console.error(error);
      loader.style.display = "none";
      loader.classList.remove("shimmer"); // Remove shimmering effect on error
      isLoading = false;
    }
  };

  // Attach the scroll event listener
  window.addEventListener("scroll", handleScroll);

  // Initial load when the page is first loaded
  loadMoreProducts();
});
